import type {BoardCell} from '../types'

/**
 * Whether this cell's first page has not been loaded yet.
 *
 * The stated count distinguishes an omitted first page from a genuinely empty cell.
 */
export function cellNeedsFirstPage(cell: BoardCell<unknown> | undefined): boolean {
  return cell?.itemsLoaded === false && (cell.totalCount ?? 0) > 0
}

/** Whether this cell has cards that are not loaded yet. */
export function cellHasUnloadedItems(cell: BoardCell<unknown> | undefined): boolean {
  return cell?.hasMoreItems === true || cellNeedsFirstPage(cell)
}
